import { Drawer } from 'antd';
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const DocumentsFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    documentType,
    storeType

}) => {
  const [placement] = useState('right');  
   const {
    userData, userDataLoading,
    documentSubType,
    costCenter, costCenterLoading
} = useSelector((state) => state.common);


const [userDataOption, setUserDataOption] = useState([]);
const [documentTypeOptions, setDocumentTypeOptions] = useState([])
const [costCenterOption, setCostCenterOption] = useState([])

useEffect(()=>{
  let typeOptions = documentType?.map(item=> {return{
    label: item.name,
    value: item.id
    }})
    setDocumentTypeOptions(typeOptions)
},[documentType])
useEffect(()=>{
   
    let _costCenter = costCenter?.map(item=> {
      return{
        label: item.name,
        value: item.id
      }
    })
    setCostCenterOption(_costCenter)
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    setUserDataOption(_userData)

},[userData, documentSubType, costCenter])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        closeIcon={
          <span 
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fee2e2",
              color: "#dc2626",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "18px",
              fontWeight: "600"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#fecaca";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <i className='la la-close' />
          </span>
        }
      >
      <div className="col mb-3 d-flex justify-content-between align-items-center">
          <h3 className="page-title" style={{ margin: 0 }}>Filters</h3>
          <span 
            onClick={handleFilterDrawer}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fee2e2",
              color: "#dc2626",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "18px",
              fontWeight: "600"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#fecaca";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <i className='la la-close' />
          </span>
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("issue_date_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "issue_date_after")}} 
        id="search" 
        label={"Issued After"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("issue_date_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "issue_date_before")}} 
        id="search" 
        label={"Issued Before"} 
        />
        </div>

      

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("expiry_date_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "expiry_date_after")}} 
        id="search" 
        label={"Expiry After"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("expiry_date_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "expiry_date_before")}} 
        id="search" 
        label={"Expiry Before"} 
        />
        </div>

     

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "document_type")}} optionLabel={"label"} optionValue={'value'} options={documentTypeOptions} value={setFilterValue("document_type")} placeholder={"Document Type"}/>
        </div>


        {/* <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "document_sub_type")}} optionLabel={"label"} optionValue={'value'} isLoading={documentSubTypeLoading} value={setFilterValue("document_sub_type")} options={documentSubTypeOption}  placeholder={"Document Sub Type"}/>
        </div> */}

        {
          storeType !== "store" &&
          <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>
        }

        

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'}  options={costCenterOption} isLoading={costCenterLoading}  value={setFilterValue("cost_center")} placeholder={"Cost Center"}/>
        </div>
      

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>

      </Drawer>
    </>
  );
};
export default DocumentsFilterDrawer;